import React from 'react';

import { getFrameWindow } from 'helpers/iframeHelpers';
import store from 'reducers/store';
import { LS, actionErrors, actionSuccesses } from 'constants/localization';
import { setAlert } from 'actions/viewActions';
import Types from 'constants/types';

// (<input index="1" />)
export const getInputIndex = event => event.target.getAttribute('index');

/*
  Constructs object from fieldReducer state.
*/
export const getFormData = (resource, useFormData) => {
  const fields = resource.fields;
  let data = null;
  if(useFormData){  
    data = new FormData();
  }else{
    data = new URLSearchParams();
  }
  if (!fields) {
    return data;
  }

  Object.values(fields)
    .filter(field => !field.disabled)
    .forEach(field => {
      // Filter undefined or null
      const values = field.values.filter(Boolean);

      // Empty string removes previous value if it exists
      if (values.length === 0) {
        if (field.type === Types.XSD.BOOLEAN) {
          data.set(field.predicate, false);
        } else {
          data.set(field.predicate, '');
        }
      }
      else if (values.length === 1) {
        data.set(field.predicate, getValue(values[0]));
      }
      else {
        // Multiple values, add [index] to form data name
        for (let i = 0; i < values.length; i++) {
          const name = `${field.predicate}[${i}]`;
          data.set(name, getValue(values[i]));
        }
      }
    });
  
  return data;
};

const getValue = (value) => {
  if (typeof value === 'object') {
    // Empty string if deleting uri link
    if (!value.uri) {
      return '';
    }
    return value.uri.startsWith('<') ? value.uri :`<${value.uri}>`;
  }
  else {
    return value ?? '';
  }
};

// Fetch metadata with signal to abort, handle errors
export const fetchMetadata = (url) => {
  const controller = new AbortController();
  // Abort fetch if component is unmounted
  getFrameWindow().addEventListener('pagehide', () => {
    controller.abort();
  });

  return fetch(url, {signal: controller.signal})
    .then(resToJsonHandleErrors)
    .catch(e => {
    // Ignore aborted fetches (navigating page while fetch still in progress)
      if (e.name == 'AbortError') {
        return;
      } throw e;
    });
};

// Handle error JSON
export const resToJsonHandleErrors = res => {
  return res.json().then(json => {
    if (res.status !== 200 || json.isError) {
      return actionError(json);
    } else {
      return json;
    }
  });
};

// Display success alert with timeout
export const actionSuccess = key => {
  store.dispatch(setAlert({
    contents: (
      <div>
        <span>{actionSuccesses[LS.getLanguage()][key]}  </span>
        <img src='images/icons/tick.png' alt='OK' title='OK' />
      </div>
    ),
    timeOut: 3000
  }));
};

export const actionError = error => {
  console.log(error);
  // Expected errors have message as key to localized error msg
  let msg = actionErrors[LS.getLanguage()][error.message];

  if (!msg) {
    msg = error.message;
  }

  const { errorCode } = error;
  if (errorCode && errorCode !== 'null') {
    msg += ` [${error.errorCode}]`;
  }
  
  store.dispatch(setAlert({ contents: msg, variant: 'danger' }));
  // Throw exception to abort Promise chain
  throw new Error(msg);
};
